module.exports = __webpack_public_path__ + "static/img/bofangluxiang2.f7ab26a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/bofangluxiang2.png
// module id = L5sT
// module chunks = 24